export default "__VITE_ASSET__CbKL0VXh__"